<template>
  <div ref="video" class="video">
    <div v-if="videoEndplayer" class="prism-player" id="J_prismPlayer">
      <div id="shuiying" class="shuiying">{{tonken}}</div>
    </div>
    <div v-if="videoEndFalse" class="videoEnd">
      <div class="abCenter">
        <div class="next">下一节课程: {{nextCoures}}</div>
        <div @click="nextButton" class="nextButton">下一节</div>
        <div @click="lookClick" class="look"><img src="./look.png" width="20" alt=""> 重新观看</div>
      </div>
    </div>

  </div>
</template>

<script>
  var player
  export default {
    data () {
      return {
        vid: '',
        playauth: '',
        allTimes: 0,
        info: {},
        htmlTime: 0,
        timer: null, // 定时器
        id: 0,
        playFalse: true,
        centerNu: require('@/components/videoLayer/video/1.png'),
        nextCoures: '',
        videoEndFalse: false,
        videoEndplayer: false,
        completeSeekFalse: true,
        tonken: '',
        animationtimer: null,
        layerBoxArray: [] // 答题数组
      }
    },
    created () {
      this.id = this.$parent.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      this.getdata()
      this.tonken = JSON.parse(localStorage.getItem('login')).username
      let that = this
      this.animationtimer = setInterval(function () {
        that.animation()
      },120000)
    },
    methods: {
      animation () {
        this.$nextTick(res => {
          $('#shuiying').css({
            left: Math.random() *  this.$refs.video.offsetWidth + 'px',
            top: Math.random() *  this.$refs.video.offsetHeight + 'px'
          })
        })
      },
      onPlayerPlaying () {
        this.playFalse = false
        this.centerNu = require('@/components/videoLayer/video/2.png')
      },
      lookClick () { // 重新看
        this.videoEndFalse = false
        player.replay()
        console.log(player)
      },
      nextButton () { // 下一章
        this.videoEndFalse = false
        this.$parent.complete()
      },
      ended () { // 全部播放完成
        this.playFalse = true
        this.centerNu = require('@/components/videoLayer/video/1.png')
        this.videoEndFalse = true
      },
      updateTime (e) { // 播放时间
        this.allTimes = 0
        this.allTimes = parseInt(player.getCurrentTime())
        for (let i = 0; i < this.layerBoxArray.length; i++) { // 判断答题弹框次数
          if (this.layerBoxArray[i].isF) {
            console.log(this.allTimes)
            console.log(this.layerBoxArray[i].key.eject_time)
            if (this.allTimes === this.layerBoxArray[i].key.eject_time) {
              this.layerBoxArray[i].isF = false
              player.fullscreenService.cancelFullScreen() // 退出全屏
              player.pause()
              this.$emit('answerClick', this.layerBoxArray[i].key)
            }
          }
        }
      },
      getdata () {
        this.$http.post('/apipx/Lesson/lessoninfo', {
          lesson_id: this.$parent.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          this.info = res.data
          if (this.info.material[0].eject_test.length > 0) { // 为0不答题
            for (let i = 0; i < this.info.material[0].eject_test.length; i++) {
              this.layerBoxArray.push({
                key: this.info.material[0].eject_test[i],
                isF: true
              })
            }
          }
          this.vid = this.info.material[0].videoid
          this.playauth = this.info.material[0].playauth.PlayAuth
          this.videoEndplayer = true
          const that = this
          player = new Aliplayer({
            id: 'J_prismPlayer',
            width: '100%',
            height: '100%',
            controlBarVisibility: 'always',
            showBuffer: false,
            autoplay: true,
            vid: that.vid,
            encryptType: 1,
            playauth: that.playauth
          }, function (player) {
          })

          player.on('ended', function (data) { // 播放结束
            that.ended()
          })

          player.on('timeupdate', function (data) { // 时间改变
            that.updateTime()
          })

        })
      }
    },
    destroyed () {
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: Math.floor(this.allTimes),
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
        clearInterval(this.animationtimer)
      })
    }
  }
</script>

<style type="text/scss" lang="scss">

  #div0 {
    width: 200px;
    height: 200px;
    position: absolute;
    z-index: 99999;
    left: 0;
    top: 0;
  }

  video {
    z-index: 9;
  }

  .video {
    width: 100%;
    height: 100%;
    position: relative;

    .shuiying {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 200px;
      height: 30px;
      z-index: 2147483647;
      font-size: 28px;
    }

    .videoEnd {
      background-color: #000;
      width: 100%;
      height: 100%;
      position: absolute;
      right: 80px;
      top: 0;
      z-index: 99999;
      color: #fff;
      text-align: center;

      .abCenter {
        width: 400px;
        margin: -76px 0 0 -200px;
        height: 152px;
        position: absolute;
        top: 50%;
        left: 50%;
        overflow: hidden;

        .next {
          width: 400px;
          font-size: 24px;
          margin: 0 auto;
        }

        .nextButton {
          width: 100px;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          background-color: #ff8484;
          border-radius: 5px;
          margin: 30px auto;
          cursor: pointer;
        }

        .look {
          cursor: pointer;
          vertical-align: middle;

          img {
            margin: 0 10px 3px 0;
          }
        }
      }
    }

    .centerNus {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -26px 0 0 -26px;
      z-index: 9;
      cursor: pointer;
    }

    .video-player {
      width: 100%;
      height: 100%;
    }

    /*.prism-player .prism-setting-btn {*/
    /*  display: none;*/
    /*}*/

    .prism-setting-cc {
      display: none;
    }

    .prism-setting-audio {
      display: none;
    }

    .prism-setting-quality {
      display: none;
    }

    .prism-player .prism-cc-btn {
      display: none;
    }

    .prism-progress-cursor {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/video/video.vue